export const login = (data) => {
    return data.data
}
export const coachRegisterApiGet = (data) => {
    return data.data
}
export const getTeamListApiGet = (data) => {
    return data.data
}
export const forgotPasswordApiGet = (data) => {
    return data.data
}
export const getTournamentGet = (data) => {
    return data.data
}
export const getSpoonseGet =(data)=>{
    return data.data
}
export const getTournamentTypeGet = (data)=>{
    return data.data
}
export const createTournamet = (data)=>{
    return data.data
}


